export const APP_UPDATE_IGNORED_PATHS = [
	'/discussion-forums',
	'/challenges',
	'/forum-tools',
	'/presentation',
	'/my-dashboard',
	'/dashboard',
	'/nerve-boards',
];

export function isIgnoredAppUpdatePath(path = '') {
	return APP_UPDATE_IGNORED_PATHS.some((ignored) => path.includes(ignored));
}

export function shouldSkipAppUpdateForNavigation(to, from) {
	if (!to?.path || to.path === from?.path) {
		return true;
	}

	return isIgnoredAppUpdatePath(to.path) || isIgnoredAppUpdatePath(from?.path);
}

// Decide whether a freshly-detected version should reload the page on its own.
// Only when auto-update is enabled AND the user is not on a long-form page where
// a reload would discard unsaved work; otherwise we surface a manual prompt.
export function shouldAutoReloadOnRefresh(path = '', { autoUpdate } = {}) {
	return Boolean(autoUpdate) && !isIgnoredAppUpdatePath(path);
}
